var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-auto ilike-btn-container"},[_c('v-btn',{attrs:{"rounded":"","block":"","color":"success","x-large":""},on:{"click":_vm.goLeadCapture}},[_vm._v(" I like it! Continue! ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }